import React from 'react';
import { Button } from '@material-ui/core';

import { useStyles } from './banner.styles';

/**
 * Generic amber notice banner: icon + title + body, with a dismiss button and a
 * primary action button. Compose the body via children (wrap emphasized text in
 * <strong> for the highlighted weight).
 */
function Banner({
    icon,
    title,
    children,
    actionLabel,
    onAction,
    actionAriaLabel,
    dismissLabel = 'Dismiss',
    onDismiss,
    dismissAriaLabel,
}) {
    const classes = useStyles();

    return (
        <div className={classes.root} role="region" aria-label={title}>
            {icon && (
                <div className={classes.iconContainer}>
                    {icon}
                </div>
            )}
            <div className={classes.textSection}>
                {title && <span className={classes.title}>{title}</span>}
                <span className={classes.body}>{children}</span>
            </div>
            <div className={classes.buttonGroup}>
                <Button
                    className={classes.dismissButton}
                    onClick={onDismiss}
                    aria-label={dismissAriaLabel}
                >
                    {dismissLabel}
                </Button>
                <Button
                    className={classes.actionButton}
                    variant="contained"
                    disableElevation
                    onClick={onAction}
                    aria-label={actionAriaLabel}
                >
                    {actionLabel}
                </Button>
            </div>
        </div>
    );
}

export default Banner;
